<template>
  <hm-content title="">
    <div class="mb20 flex flex-between">
      <div>
        <el-radio-group
          v-model="searchCondition.status"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="hongBao">红包流水</el-radio-button>
          <el-radio-button label="chongZhi">充值流水</el-radio-button>
          <el-radio-button label="guider_refund_profit"
            >退单流水</el-radio-button
          >
        </el-radio-group>
      </div>
      <div>
        当前供货商: <span class="primary">{{ storeName }}</span>
      </div>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button
          type="primary"
          size="small"
          class="mr10"
          @click="artificial"
          v-if="searchCondition.status === 'chongZhi'"
          >人工充值</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="goReview"
          v-if="searchCondition.status === 'chongZhi'"
          >审核充值</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="goRecharge"
          v-if="
            searchCondition.status === 'chongZhi' && percentageMode === 'pack'
          "
          >套餐购买</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="goUseRecord"
          v-if="
            searchCondition.status === 'chongZhi' && percentageMode === 'pack'
          "
          >套餐使用流水</el-button
        >
      </div>

      <div v-if="searchCondition.status === 'chongZhi'">
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请选择审核状态"
          v-model="searchCondition.rechargeState"
        >
          <el-option label="待审核" value="wait"> </el-option>
          <el-option label="充值成功" value="yes"> </el-option>
          <el-option label="驳回" value="no"> </el-option>
        </el-select>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择充值时间段"
          end-placeholder="选择充值时间段"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchs">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(searchCondition.status)"
          :loading="isOutputing"
          >导出报表</el-button
        >
      </div>
      <div
        style="
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-end;
          align-items: center;
        "
        v-else
      >
        <div style="width: 160px;overflow: hidden;">
          <el-select
          style="width: 160px"
          v-if="
            searchCondition.storeOrShopIds &&
            searchCondition.storeOrShopIds.length > 0
          "
          v-model="selectedOptions"
          size="small"
          multiple
          placeholder="所选门店"
        >
          <el-option
            v-for="item in allOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
        </div>

        <!-- <el-tooltip
          class="item"
          style="margin-right: 20px"
          effect="dark"
          :content="selectedOptions"
          placement="bottom"
        >
          <el-input v-model="selectedOptions" placeholder="所选商户门店" :disabled="true" size="small"></el-input>
        </el-tooltip> -->
        <!-- <el-button v-if="searchCondition.storeOrShopIds && searchCondition.storeOrShopIds.length > 0" type="primary" size="small" class="mr10" @click="deleteShops"
          >清空所选门店</el-button
        > -->
        <div
          style="
            color: #e50065;
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
            margin: 0 20px;
          "
          v-if="
            searchCondition.storeOrShopIds &&
            searchCondition.storeOrShopIds.length > 0
          "
          @click="deleteShops"
        >
          清空
        </div>
        <!-- <el-button v-else type="primary" size="small" class="mr10" @click="openVisible"
          >选择门店</el-button
        > -->
        <div
          v-else
          style="
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;
            width: 80px;
            cursor: pointer;
          "
          @click="openVisible"
        >
          <img
            style="width: 16px; height: 16px; margin-right: 6px"
            class="avatar"
            src="@/assets/shaixuan.png"
            alt=""
          />
          <div style="font-size: 15px; color: #909399; margin-right: 10px">
            筛选
          </div>
        </div>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择发放时间段"
          end-placeholder="选择发放时间段"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(searchCondition.status)"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>

    <div class="table" v-if="searchCondition.status === 'chongZhi'">
      <el-table
        :data="companyRechargelist.records"
        style="width: 100%"
        ref="chongZhi"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值方式"
          prop="rechargeModes"
        >
          <template slot-scope="scope">
            {{ scope.row.rechargeMode === "wx_pay" ? "线上充值" : "人工充值" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="审核状态"
          prop="rechargeState"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.rechargeMode === 'wx_pay'">
              <span
                class="status success"
                :class="scope.row.status"
                v-if="scope.row.rechargeState === 'yes'"
                >充值成功</span
              >
              <span
                class="status danger"
                v-if="scope.row.rechargeState === 'no'"
                >充值失败</span
              >
            </div>
            <div v-else>
              <span
                class="status success"
                :class="scope.row.status"
                v-show="scope.row.rechargeState === 'yes'"
                >充值成功</span
              >
              <span
                class="status blue"
                :class="scope.row.status"
                v-show="scope.row.rechargeState === 'wait'"
                >待审核</span
              >
              <span
                class="status danger"
                :class="scope.row.status"
                v-show="scope.row.rechargeState === 'no'"
                >驳回</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值账号"
          prop="rechargeAccount"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值单号"
          prop="rechargeSn"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.rechargeSn }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值时间"
          prop="rechargeTime"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="rechargeMoney"
          label="充值金额"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.rechargeMoney }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rechargeAfterBalance"
          label="账户余额"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.rechargeAfterBalance }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rechargeMoney"
          label="备注"
        >
          <template slot-scope="scope">
            {{
              scope.row.rechargeMode === "wx_pay" ? "" : scope.row.rechargeMode
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="充值人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.auditUsername }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.auditTime }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="pass(scope.row)"
                :disabled="
                  scope.row.rechargeState === 'yes' ||
                    scope.row.rechargeState === 'no'
                "
                >通过</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="reject(scope.row)"
                :disabled="
                  scope.row.rechargeState === 'yes' ||
                    scope.row.rechargeState === 'no'
                "
                >驳回</el-button
              >
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="companyRechargelist.total"
          @current-change="pagingRecharge"
          @size-change="handleSizeChangeRecharge"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-else>
      <el-table
        :data="companyCapitalFlowlist.records"
        style="width: 100%"
        ref="hongBao"
        stripe
        border
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="导购姓名"
          prop="guiderName"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="退款单号"
          prop="receiptSn"
          v-if="searchCondition.status === 'guider_refund_profit'"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="申报单关联小票号"
          prop="receiptSn"
          v-else
        >
          <template slot-scope="scope">
            {{ scope.row.receiptSn }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="关联申报单号"
          prop="declareSn"
          v-if="searchCondition.status === 'guider_refund_profit'"
        >
          <template slot-scope="scope">
            {{ scope.row.declareSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="手机号"
          prop="guiderPhone"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
        >
          <template slot-scope="scope">
            {{ scope.row.shopName }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="结算商品"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="tradeTime"
          label="奖励日期"
        >
          <template slot-scope="scope">
            {{ scope.row.tradeTime }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="tradeTime"
          label="扣减时间"
        >
          <template slot-scope="scope">
            {{ scope.row.tradeTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tradeMoney"
          label="扣减金额"
          key="tradeMoney"
        >
          <template slot-scope="scope">
            <div class="primary">
              {{ searchCondition.status === "guider_refund_profit" ? "-" : "" }}
              ¥{{ scope.row.tradeMoney }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="feeMoney"
          label="平台服务费"
        >
          <template slot-scope="scope">
            <div class="primary">- ¥{{ scope.row.feeMoney }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="afterBalance"
          label="账户余额"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.afterBalance }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="companyCapitalFlowlist.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="人工充值"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="充值金额" prop="rechargeMoney">
          <el-input
            clearable
            v-model.trim="ruleForm.rechargeMoney"
            @input="filterGt0OrFixed2('rechargeMoney')"
            size="small"
            placeholder="请输入充值金额"
          ></el-input>
        </el-form-item>

        <el-form-item label="充值账号" prop="rechargeAccount">
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="请选择充值账号"
            v-model="ruleForm.rechargeAccount"
            filterable
          >
            <el-option
              :label="account.itemText"  
              :value="account.itemValue" 
              v-for="(account, i) in rechargeAccountList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="rechargeMode">
          <el-input
            clearable
            v-model.trim="ruleForm.rechargeMode"
            style="width: 300px"
            size="small"
            placeholder="请输入充值方式（如:微信/支付宝/中国银行）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="选择门店"
      width="1600px"
      :before-close="qx"
      :visible.sync="storeVisible"
    >
      <div class="flex">
        <div class="mr10" style="width: 600px">
          <div class="table-panel flex flex-between">
            <div class="fr" style="width: 100%">
              <el-button
                class="fr"
                style="margin-right: 10px"
                type="primary"
                size="small"
                @click="storeSearch"
                >查询</el-button
              >
              <el-input
                clearable
                v-model.trim="storesNames"
                placeholder="请输入商户"
                size="small"
                class="ipt mr10 fr"
              >
              </el-input>
            </div>
          </div>
          <div class="table-panel">
            <div class="tables">
              <el-table
                stripe
                ref="roleTable"
                :data="storeBasucList.records"
                style="width: 100%"
                id="table"
                @row-click="tableSelect"
                size="small"
                border
                max-height="500"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  :index="
                    (index) =>
                      index + (storeCurrentPage - 1) * storePageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopCount"
                  width="90"
                  label="门店数"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                background
                small
                :pager-count="5"
                :total="storeBasucList.total"
                @current-change="storePaging"
                @size-change="storeHandleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="storeCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="mar10 seach_checked">
          <el-button class="btn" type="primary" size="small" @click="searchShop"
            >查询勾选商户门店</el-button
          >
        </div>
        <div class="mr10 w60" style="width: 800px">
          <div class="table-panel flex flex-between">
            <div class="fr">
              <el-input
                clearable
                v-model.trim="shopName"
                placeholder="请输入门店名称"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="shopSearch"
                >查询</el-button
              >
            </div>
          </div>
          <div class="table-panel">
            <div class="table">
              <el-table
                stripe
                ref="rightData"
                :data="notRelShopList.records"
                style="width: 100%"
                id="table"
                size="small"
                @row-click="rightTableSelect"
                @selection-change="getShopChecked"
                border
                max-height="500"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  :index="
                    (index) => index + (shopCurrentPage - 1) * shopPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  width="150"
                  prop="shopName"
                  label="门店名称"
                >
                  <template slot-scope="scope">
                    <div class="flex item-center">
                      <span>{{ scope.row.shopName }}</span>
                      <span
                        v-if="scope.row.shopMonthlyStatementFlag"
                        class="monthlyStatement-wrapper"
                        >月结</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="所在省/市/区"
                  prop="citys"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.provinceName }}{{ scope.row.cityName
                      }}{{ scope.row.districtName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="详细地址"
                  prop="shopAddress"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="组织机构代码"
                  prop="orgCode"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                small
                background
                :total="notRelShopList.total"
                @current-change="shopPaging"
                @size-change="shopHandleSizeChange"
                layout="total,sizes, prev, pager, next, jumper"
                :current-page="shopCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="submitAllStore()"
          >确 定</el-button
        >
        <el-button size="small" @click="qx">取 消</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="选择门店"
      :close-on-click-modal="false"
      :visible.sync="storeVisible"
      width="1000px"
      :before-close="handleClose"
    >
      <div
        class="flex"
        style="
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
        "
      >
        <el-input
          v-model="storesNames"
          size="small"
          clearable
          style="width: 350px"
          class="mr10"
          ref="storeref"
          placeholder="请选择商户"
        ></el-input>
        <el-button
          style="height: 76%"
          type="primary"
          size="mini"
          class="mr10"
          @click="searchAll"
          >搜索</el-button
        >
      </div>
      <el-dialog
        width="80%"
        title="商户"
        :visible.sync="innerDialogVisible"
        append-to-body
      >
        <el-table
          :data="newStores"
          @current-change="getChecked"
          highlight-current-row
          style="width: 100%"
          ref="singleTable"
          id="table"
          size="small"
          border
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户店铺"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="storesTotal"
            :page-size="100"
            @current-change="storePaging"
            layout="total,  prev, pager, next, jumper"
            :current-page="storeCurrent"
          ></el-pagination>
          <span slot="footer" class="dialog-footer flex flex-center mt20">
            <el-button @click="addAllStore" size="small" type="primary">
              搜索门店</el-button
            >
          </span>
        </div>
      </el-dialog>
      <div style="width: 100%;margin-top: 20px;">
        <el-form
          :model="ruleForms"
          ref="ruleForms"
          :inline="false"
          style="width: 100%"
        >
          <el-form-item>
            <el-table
              :data="
                ruleForms.storeCodeList.slice(
                  (supplierCurrent - 1) * pageStoreSize,
                  supplierCurrent * pageStoreSize
                )
              "
              @selection-change="getStoreId"
              style="width: 100%"
              size="small"
              border
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
                :index="(index) => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="商户店铺"
              ></el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="supplierTotal"
                :page-size="pageStoreSize"
                @current-change="supplierPaging"
                layout="total, prev, pager, next, jumper"
                :current-page="supplierCurrent"
              ></el-pagination>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog> -->
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      storeName: "",
      shopName: "",
      storeVisible: false,
      innerDialogVisible: false,
      selectedOptions: [],
      allOptions: [],
      checkedStoreId: "",
      storename: "",
      storesNames: "",
      storeCurrentPage: 1,
      storePageSize: 10,
      shopCurrentPage: 1,
      shopPageSize: 10,
      newStores: [],
      props: {
        lazy: true,
        checkStrictly: true,
        multiple: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryStoreBasicInfoTree", {
                pageNo: 1,
                pageSize: 999,
                storeName: "桂林",
                supplierCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.leaf = Boolean(v.shopCount > 0 ? false : true);
                  v.value = v.storeCode;
                  v.label = v.storeName;
                });
                resolve(res.result);
              });
          } else if (level === 1) {
            this.$store
              .dispatch("queryStoreShopInfoTree", {
                storeCode: data.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = true;
                    v.value = v.shopId;
                    v.label = v.shopName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          } else {
            resolve([]);
          }
        },
      },
      storeOrShopIds: [],
      optionList: [],
      storeShopName: "",
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      searchCondition: {
        status: "hongBao",
        applyDate: [],
      },
      ruleForms: {
        storeCodeList: [],
      },
      ruleForm: {
        rechargeMoney: "",
        rechargeAccount: "",
        // rechargeSn: "",
        rechargeMode: "",
      },
      rules: {
        rechargeMoney: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur",
          },
        ],
        rechargeAccount: [
          {
            required: true,
            message: "请选择充值账号",
            trigger: "blur",
          },
        ],
        rechargeSn: [
          {
            required: true,
            message: "请输入充值单号",
            trigger: "blur",
          },
        ],
        rechargeMode: [
          {
            required: true,
            message: "请输入充值方式",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      percentageMode: "",
      resetForm: true,
    };
  },
  computed: mapGetters([
    "companyCapitalFlowlist",
    "companyRechargelist",
    "allCompanyCapitalFlowlist",
    "redpackageOutletRelList",
    "storeBasicInfoListBox",
    "storeBasucList",
    "notRelShopList",
  ]),
  watch: {},
  created() {
    const startTime = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    this.queryRechargeAccountList();
    this.searchCondition.applyDate = [startTime, endTime];
  },
  mounted() {
    this.storeName = localStorage.getItem("storeName");
    this.percentageMode = this.$route.query.percentageMode;
    this.queryList();
  },
  methods: {
    deleteShops() {
      this.searchCondition.storeOrShopIds = [];
      this.selectedOptions = "";
      this.storesNames = "";
    },
    submitAllStore() {
      if (this.checkedShopRow <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        let arrs = [],
          subArrs = [],
          storeOrShopIds = [];
        this.checkedShopRow.forEach((v, index) => {
          console.log(index);
          let items = {
            label: v.shopName,
            value: v.shopCode,
            disabled: true
          };
          let itemList = [];
          itemList[0] = v.storeCode;
          itemList[1] = v.shopId;
          arrs.push(items);
          if (index == 0) {
            subArrs.push(items.label);
          }
          // subArrs.push(items.label);
          // if (index == 0) {
          //   subArrs = `${subArrs}${v.shopName}`;
          // } else {
          //   subArrs = `${subArrs}, ${v.shopName}`;
          // }
          storeOrShopIds.push(itemList);
          if (v.departIds && v.departIds.length > 0) {
            v.departId = v.departIds[v.departIds.length - 1];
          }
        });
        this.allOptions = arrs;
        this.selectedOptions = subArrs;
        this.storeVisible = false;
        this.searchCondition.storeOrShopIds = storeOrShopIds;
        console.log(
          this.checkedShopRow,
          "提交后的数组",
          this.allOptions,
          this.selectedOptions
        );
      }
    },
    queryShopList() {
      let params = {
        pageSize: this.shopPageSize,
        pageNo: this.shopCurrentPage,
        shopName: this.shopName,
        storeCodeList: this.storeCodeList,
        supplierCode: this.$route.query.storeCode,
      };
      this.$store.dispatch("queryFindRelShopList", params);
    },
    //左边表格表格选中
    tableSelect(row) {
      this.$refs.roleTable.toggleRowSelection(row);
    },
    handleSelectionChange(row) {
      this.storeCodeList = row.map((v) => v.storeCode);
    },
    storeHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryStoreList();
    },
    shopSearch() {
      this.shopCurrentPage = 1;
      this.queryShopList();
    },
    rightTableSelect(row, column) {
      if (column.label != "对应组织机构") {
        this.$refs.rightData.toggleRowSelection(row);
      }
    },
    getShopChecked(selection) {
      this.checkedShopRow = selection;
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.queryShopList();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.queryShopList();
    },
    searchShop() {
      this.canClick = false;
      if (this.storeCodeList.length) {
        this.shopCurrentPage = 1;
        this.importData = false;
        console.log('1',this.queryShopList());
        this.queryShopList();
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning",
        });
      }
    },
    queryStoreList() {
      let params = {
        pageSize: this.storePageSize,
        pageNo: this.storeCurrentPage,
        storeName: this.storesNames,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      };
      this.$store.dispatch("queryStoreBasicList", params);
    },
    qx() {
      this.storeVisible = false;
      this.rest();
    },
    rest() {
      setTimeout(() => {
        this.departIds = "";
        this.storeCode = "";
        this.storeName = "";
        this.shopName = "";
        this.storeBasucList.records = [];
        this.storeBasucList.total = 0;
        this.notRelShopList.records = [];
        this.notRelShopList.total = 0;
      }, 0);
    },
    storeSearch() {
      this.storeCurrentPage = 1;
      this.queryStoreList();
    },
    uniqueByKey(arr, key) {
      const seen = {};
      return arr.filter((item) => {
        const k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      });
    },
    submitForm() {
      const storeOrShopIds = [];
      this.storeVisible = false;
      storeOrShopIds.push(this.checkedStoreId[0].storeCode);
      storeOrShopIds.push(this.checkedStoreId[0].shopId);
      this.searchCondition.storeOrShopIds = [];
      this.searchCondition.storeOrShopIds[0] = storeOrShopIds;
      this.storesNames = "";
      this.ruleForms.storeCodeList = [];
      this.storesTotal = 0;
      this.supplierTotal = 0;
      console.log(this.searchCondition.storeOrShopIds);
    },
    getStoreId(e) {
      console.log("选择门店", e);
      this.checkedStoreId = e;
    },
    supplierPaging(page) {
      this.supplierCurrent = page;
    },
    async queryRechargeAccountList() {
  //  "recharge_account_code" 是字典项的代码，用于查询充值账号。
      const { result } = await this.$store.dispatch("queryDictItemsCode", { dictCode: "recharge_account_code" });
      this.rechargeAccountList = result;
      console.log("result", result);
    },

    async addAllStore() {
      let newArr = this.allStoreList;
      // let uniqueArray = this.uniqueByKey(newArr, (item) => item.storeCode);
      // console.log(newArr, uniqueArray);
      // this.ruleForm.storeCodeList = uniqueArray;
      let params = {
        pageNo: this.supplierCurrent,
        pageSize: 100,
        storeCode: newArr[0].storeCode,
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopInfoLists",
        params
      );
      console.log("模糊搜索", result);
      // result.map(item => {
      //   item.storeCode = newArr[0].storeCode;
      //   return item;
      // })
      this.ruleForms.storeCodeList = result.records;
      this.supplierTotal = result.records.length;
      this.innerDialogVisible = false;
    },
    storePaging(page) {
      this.storeCurrentPage = page;
      this.queryStoreList();
    },
    async getChecked(e) {
      console.log("单选", e);
      const arr = [];
      arr.push(e);
      this.allStoreList = arr;
    },
    async searchAll() {
      let params = {
        pageNo: this.storeCurrent,
        pageSize: 100,
        // createTimeEnd: "",
        // createTimeStart: "",
        storeName: this.storesNames,
        supplierCode: this.$route.query.storeCode,
      };
      if (this.storesNames == "") {
        this.$message.error("请输入商户名称");
      } else {
        const { result } = await this.$store.dispatch(
          "findStorePageByType",
          params
        );
        console.log("模糊搜索", result);
        this.newStores = result.records || [];
        this.storesTotal = result.total;
        console.log(this.newStores);
        this.innerDialogVisible = true;
      }
    },
    handleClose() {
      console.log("关闭");
      this.storeVisible = false;
      this.storesNames = "";
      this.ruleForms.storeCodeList = [];
      this.storesTotal = 0;
      this.supplierTotal = 0;
    },
    openVisible() {
      this.storeVisible = true;
      this.notRelShopList.records = [];
      this.notRelShopList.total = 0;
      this.shopCurrentPage = 1;
      this.shopPageSize = 10;
      this.queryStoreList();
    },
    searchShopName(e) {
      console.log(e);
      if (e != "" || e != "") {
        this.$store
          .dispatch("queryStoreBasicInfoTree", {
            pageNo: 1,
            pageSize: 999,
            storeName: e,
            supplierCode: this.$route.query.storeCode,
          })
          .then((res) => {
            res.result.forEach((v) => {
              v.leaf = Boolean(v.shopCount > 0 ? false : true);
              v.value = v.storeCode;
              v.label = v.storeName;
            });
            this.optionList = res.result;
          });
      }
    },
    filterChange(node, val) {
      console.log(node, val);
    },
    goRecharge() {
      this.$router.push({
        name: "RechargeCenter",
        query: {
          storeCode: this.$route.query.storeCode,
        },
      });
    },
    goUseRecord() {
      this.$router.push({
        name: "RechargeDetails",
        query: {
          storeCode: this.$route.query.storeCode,
        },
      });
    },
    goReview() {
      this.$router.push({
        name: "Review",
        query: {
          storeCode: this.$route.query.storeCode,
        },
      });
    },
    switchTab(val) {
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      if (val === "chongZhi") {
        this.pageSize = 10;
        this.currentPage = 1;
        this.queryCompanyList();
      } else {
        this.pageSize = 10;
        this.currentPage = 1;
        this.queryList();
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchs() {
      this.currentPage = 1;
      this.queryCompanyList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingRecharge(page) {
      this.currentPage = page;
      this.queryCompanyList();
    },
    handleSizeChangeRecharge(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryCompanyList();
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.billType =
        searchCondition.status === "hongBao"
          ? "receipt_order"
          : "guider_refund_profit";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCompanyCapitalFlowlist", params);
    },
    queryCompanyList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.rechargeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.rechargeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCompanyRechargelist", params);
    },
    queryAllCompanyList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        storeCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.rechargeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.rechargeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCompanyRechargelist", params);
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCompanyCapitalFlowlist", params);
    },
    // 导出excel
    async output(status) {
      let params = {
        storeCode: this.$route.query.storeCode,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.rechargeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.rechargeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.billType =
        searchCondition.status === "hongBao"
          ? "receipt_order"
          : "guider_refund_profit";
      Object.assign(params, searchCondition);
      if (status === "chongZhi") {
        await this.$store.dispatch("companyRechargeList", params);
      } else {
        await this.$store.dispatch("companyCapitalFlowList", params);
      }
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
      // if (status === "hongBao") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;

      //     this.queryAllList()
      //       .then(res => {
      //         const list = res.result.records;
      //         list.forEach(v => {
      //           v.citys = v.provinceName + v.cityName + v.districtName;
      //         });
      //         const tHeader = this.$refs.hongBao.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.hongBao.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }
      //         const data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(
      //           tHeader,
      //           data,
      //           "红包流水" + new Date().toLocaleString()
      //         );
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (status === "chongZhi") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllCompanyList()
      //       .then(res => {
      //         const list = res.result.records;
      //         list.forEach(v => {
      //           v.rechargeModes =
      //             v.rechargeMode === "wx_pay" ? "线上充值" : v.rechargeMode;
      //           if (v.rechargeMode === "wx_pay") {
      //             if (v.rechargeState === "yes") {
      //               v.rechargeState = "充值成功";
      //             } else {
      //               v.rechargeState = "充值失败";
      //             }
      //           } else {
      //             if (v.rechargeState === "yes") {
      //               v.rechargeState = "充值成功";
      //             } else if (v.rechargeState === "wait") {
      //               v.rechargeState = "待审核";
      //             } else if (v.rechargeState === "no") {
      //               v.rechargeState = "驳回";
      //             }
      //           }
      //         });
      //         const tHeader = this.$refs.chongZhi.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.chongZhi.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }

      //         const data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(
      //           tHeader,
      //           data,
      //           "充值流水" + new Date().toLocaleString()
      //         );
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    artificial() {
      this.dialogVisible = true;
    },
    pass(row) {
      this.$confirm(`是否通过？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          if (res === "confirm") {
            this.$store
              .dispatch("auditRechargeOrder", {
                rechargeId: row.rechargeId,
                rechargeState: "yes",
              })
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.queryCompanyList();
                }
              });
          }
        })
        .catch(() => {});
    },
    reject(row) {
      this.$confirm(`是否驳回？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          if (res === "confirm") {
            this.$store
              .dispatch("auditRechargeOrder", {
                rechargeId: row.rechargeId,
                rechargeState: "no",
              })
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.queryCompanyList();
                }
              });
          }
        })
        .catch(() => {});
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleForm;
          params.storeCode = this.$route.query.storeCode;

          this.$store.dispatch("saveRechargeOrder", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.dialogVisible = false;
              this.queryCompanyList();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.seach_checked {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
}
</style>
